import styled, { css } from 'styled-components';

import { GridContent, GridLayout, mediaMixin, token } from '@zillow/constellation';

export const StyledGrid = styled(GridLayout)`
  text-align: center;
  gap: 24px;
`;

export const StyledGridSection = styled(GridContent)`
  border: 1px solid ${token('colors.gray300')};
  ${mediaMixin(
    'sm_lte',
    css`
      border: none;
    `,
  )}
`;
